export enum FormInputLayout {
  Standard = 'standard',
  Outline = 'outline',
}
